import React from 'react';
import { useVHWebModalContext } from './VHWebModalBaseContext';

const VHWebModalBase = () => {
  const vhWebModalRef = useVHWebModalContext();
  return <div style={{ position: 'absolute' }} ref={vhWebModalRef}></div>;
};

export default VHWebModalBase;
